var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTgChat = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "-0.75 -0.25 15.5 15.5"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M3.917 5.148c1.022 0 1.85-.816 1.85-1.824 0-1.007-.828-1.824-1.85-1.824-1.02 0-1.849.817-1.849 1.824s.828 1.824 1.85 1.824Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M5.767 7.418H3.24c-.45 0-.886.163-1.224.457s-.555.7-.61 1.141l-.395 3.116a1.2 1.2 0 0 0 .299.956 1.23 1.23 0 0 0 .924.41h2.918m7.84-1.366-.395-3.116a1.82 1.82 0 0 0-.611-1.142 1.86 1.86 0 0 0-1.224-.456H9.402c-.45 0-.886.163-1.223.457s-.555.7-.611 1.141l-.395 3.116a1.2 1.2 0 0 0 .299.956 1.23 1.23 0 0 0 .925.41h3.37a1.25 1.25 0 0 0 .924-.41 1.21 1.21 0 0 0 .3-.956"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 1.5,
  d: "M10.082 5.148c1.02 0 1.849-.816 1.849-1.824 0-1.007-.828-1.824-1.85-1.824-1.02 0-1.849.817-1.849 1.824s.828 1.824 1.85 1.824Z"
})));
export default SvgTgChat;